import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'; // For beautiful alerts

const AddCategory = () => {
  const [name, setName] = useState('');
  const [sortrank, setSortrank] = useState('');
  const [customId, setCustomId] = useState('');
  const [userLabId, setUserLabId] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // On component mount: Retrieve userLabId from localStorage
  useEffect(() => {
    const labId = localStorage.getItem('userLabId');
    
    if (labId) {
      setUserLabId(labId);
    } else {
      // Show warning if userLabId is missing (critical for addedBy field)
      Swal.fire({
        icon: 'warning',
        title: 'Session Expired',
        text: 'User information not found. Please log in again.',
        confirmButtonColor: '#004aad',
      }).then(() => {
        // Optional: redirect to login if needed
        // navigate('/login');
      });
    }
  }, []);

  // Form submission handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation: Name is required
    if (!name.trim()) {
      Swal.fire({
        icon: 'error',
        title: 'Missing Information',
        text: 'Please enter a category name',
        confirmButtonColor: '#dc3545',
      });
      return;
    }

    // Ensure userLabId exists before sending request
    if (!userLabId) {
      Swal.fire({
        icon: 'error',
        title: 'Authentication Error',
        text: 'User information not found. Please log in again.',
        confirmButtonColor: '#dc3545',
      });
      return;
    }

    setLoading(true);

    // Prepare data to send to backend
    const requestData = {
      name: name.trim(),
      sortrank: sortrank.trim(),
      customId: customId.trim(),
      addedBy: userLabId, // Links category to the logged-in user/lab
    };

    try {
      const response = await fetch('https://hms.backend.hiragroupcloud.com/api/categories', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();

      if (response.ok) {
        // Success: Show nice confirmation
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Category added successfully!',
          confirmButtonColor: '#28a745',
          timer: 1500,
          showConfirmButton: false
        });

        // Reset form fields
        setName('');
        setSortrank('');
        setCustomId('');

        // Navigate back after short delay for user to see success message
        setTimeout(() => {
          navigate('/case-setting');
        }, 1600);
      } else {
        // Server returned error (e.g., duplicate name, validation fail)
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: result.message || 'Could not add category. Please try again.',
          confirmButtonColor: '#dc3545',
        });
      }
    } catch (error) {
      // Network or unexpected error
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'Unable to connect to server. Please check your internet connection and try again.',
        confirmButtonColor: '#dc3545',
      });
    } finally {
      setLoading(false);
    }
  };

  // Cancel and go back
  const handleCancel = () => {
    navigate('/caseSetting');
  };

  return (
    <div style={{ width: "1900px", margin: "0 auto", padding: "0px" }}>
      <div className="row">
        <div className="col-md-10">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h2>Add Display Category</h2>
            {/* Debug button removed as per cleanup request */}
          </div>
          
          <h4 style={{ color: "#004aad" }}>Details</h4>
          <div style={{ backgroundColor: "#f0f0f0", borderTop: "2px solid #004aad", padding: "20px" }}>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label>
                  Name <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  disabled={loading}
                  placeholder="Enter category name"
                />
              </div>

              <div className="form-group mb-3">
                <label>Sort Rank</label>
                <input
                  type="text"
                  className="form-control"
                  value={sortrank}
                  onChange={(e) => setSortrank(e.target.value)}
                  disabled={loading}
                  placeholder="e.g., 1, 2, 10 (optional)"
                />
              </div>

              <div className="form-group mb-3">
                <label>Custom ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={customId}
                  onChange={(e) => setCustomId(e.target.value)}
                  disabled={loading}
                  placeholder="Optional custom identifier"
                />
              </div>

              {/* Hidden field for tracking who added the category */}
              <input type="hidden" value={userLabId} name="addedBy" />

              <div className="d-flex gap-2 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading || !userLabId}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Adding...
                    </>
                  ) : (
                    'Submit'
                  )}
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;